import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { NotificationSettings } from '@eggplant/types'

interface Props {
  onSuccess?: () => void
  params?: NotificationSettings
}

const UpdateNotificationSettingsRequest = ({
  onSuccess,
  params
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/settings`

  return (
    <AuthenticatedDataRequest
      method='put'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateNotificationSettingsRequest
